module.exports = __webpack_public_path__ + "static/img/no_photo.a2e58330.png";